import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { api } from "@/lib/api";

export const MessagesNavLink = ({ className, testid, label = "Messaggi" }) => {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    const load = () => api.get("/conversations/unread").then((r) => setUnread(r.data.unread)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    window.addEventListener("messages:read", load);
    return () => { clearInterval(t); window.removeEventListener("messages:read", load); };
  }, []);
  return (
    <NavLink to="/messaggi" className={(s) => `${className(s)} relative`} data-testid={testid}>
      {label}
      {unread > 0 && <span className="absolute -top-2 -right-4 min-w-[16px] h-[16px] px-1 bg-[#D4AF37] text-[#0B0C0E] text-[9px] font-bold flex items-center justify-center rounded-full" data-testid={`${testid}-unread`}>{unread}</span>}
    </NavLink>
  );
};
